import { render, staticRenderFns } from "./accountSet.vue?vue&type=template&id=1f70533f&"
import script from "./accountSet.vue?vue&type=script&lang=js&"
export * from "./accountSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports